export enum FieldMandatoryType {
  MANDATORY,
  OPTIONAL,
  MANDATORY_ON_CERTIFICATE,
}
